import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Coins, DollarSign, Server, TrendingUp } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";
import { tokenOverview } from "../../api/wallet";
import { usePerms } from "../../hooks/usePerms";

export const TokenOverview = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const canBilling = usePerms().can("billing");

  useEffect(() => {
    if (!canBilling) return;
    (async () => setData(await tokenOverview()))();
  }, [canBilling]);

  if (!data || !canBilling) return null;
  const cur = data.currency.toUpperCase();
  const cards = [
    { key: "tokensUsed", value: data.tokens_used_month, icon: Coins, accent: true },
    { key: "revenue", value: `${data.revenue_month} ${cur}`, icon: DollarSign, accent: true },
    { key: "awsCost", value: `${data.aws_cost_month} ${cur}`, icon: Server },
    { key: "margin", value: `${data.margin_month} ${cur}`, icon: TrendingUp, accent: true },
  ];

  return (
    <div data-testid="token-overview">
      <p className="label-xs mb-3">{t("tokens.overview", { month: data.month })}</p>
      <div className="grid grid-cols-2 gap-4 xl:grid-cols-4">
        {cards.map((c) => (
          <StatCard
            key={c.key}
            testId={`token-stat-${c.key}`}
            label={t(`tokens.${c.key}`)}
            value={c.value}
            icon={c.icon}
            accent={c.accent}
          />
        ))}
      </div>
      <p className="mt-3 text-xs text-muted-foreground" data-testid="token-overview-note">
        {t("tokens.note", {
          marginal: data.marginal_cost_per_image,
          faces: data.stored_faces,
          storage: data.aws_storage_cost_month,
          currency: cur,
          sold: data.tokens_sold_total,
        })}
      </p>
    </div>
  );
};
